<template>
  <div>
    <bread-cump :cumps="$route.meta.breadcrumps" :params="$route.params" />

    <v-container fluid>
      <v-row class="ml-3">
        <h4>Month : {{ $route.params.month }}</h4>
        <h4 class="ml-3">Year : {{ $route.params.year }}</h4>
      </v-row>
      <v-row>
        <v-col lg="12">
          <v-card class="card--shadow">
            <list
              @filterAlert="filterAlert"
              @clearAlert="clearAlert"
              :homeVisitData="homeVisitData"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import List from "@/components/home-visit/List";
import { mapState } from "vuex";
import BreadCump from "@/components/navigation/BreadCump";
export default {
  components: {
    List,
    BreadCump,
  },
  computed: {
    ...mapState("HomeVisit", ["homeVisitData"]),
  },
  methods: {
    filterAlert(is_alert) {
      this.$store.dispatch("HomeVisit/getAll", {
        month: this.$route.params.month,
        year: this.$route.params.year,
        is_alert,
      });
      this.$router.replace({
        name: "home-visit",
        params: {
          month: this.$route.params.month,
          year: this.$route.params.year,
        },
        query: {
          is_alert,
        },
      });
    },
    clearAlert() {
      this.$store.dispatch("HomeVisit/getAll", {
        month: this.$route.params.month,
        year: this.$route.params.year,
      });
      this.$router.replace({
        name: "home-visit",
        params: {
          month: this.$route.params.month,
          year: this.$route.params.year,
        },
      });
    },
  },
  created() {
    const params = {
      month: this.$route.params.month,
      year: this.$route.params.year,
    };
    if (this.$route.query.is_alert)
      params.is_alert = this.$route.query.is_alert;
    this.$store.dispatch("HomeVisit/getAll", params);
  },
};
</script>
